exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1zTBeS0u0009bjYjXl3Xmj,._2HDLEpl4nytn7veH1ek_6w,._1cHmr102aEhfOG0D32r1zB{padding-left:20px;padding-right:20px}@media only screen and (min-width: 480px){._1zTBeS0u0009bjYjXl3Xmj,._2HDLEpl4nytn7veH1ek_6w,._1cHmr102aEhfOG0D32r1zB{padding-left:36px;padding-right:36px}}@media only screen and (min-width: 1280px){._1zTBeS0u0009bjYjXl3Xmj,._2HDLEpl4nytn7veH1ek_6w,._1cHmr102aEhfOG0D32r1zB{padding-left:52px;padding-right:52px}}._22bc-kkDntp3G2ZN2DFuWk{margin-left:20px;margin-right:20px}@media only screen and (min-width: 480px){._22bc-kkDntp3G2ZN2DFuWk{margin-left:36px;margin-right:36px}}@media only screen and (min-width: 1280px){._22bc-kkDntp3G2ZN2DFuWk{margin-left:52px;margin-right:52px}}._2HDLEpl4nytn7veH1ek_6w{margin-bottom:24px}._1cHmr102aEhfOG0D32r1zB{margin-top:var(--music-spacer-large);margin-bottom:0;cursor:default;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}\n", ""]);

// exports
exports.locals = {
	"grid-sides": "_1zTBeS0u0009bjYjXl3Xmj",
	"gridSides": "_1zTBeS0u0009bjYjXl3Xmj",
	"button-container": "_2HDLEpl4nytn7veH1ek_6w",
	"buttonContainer": "_2HDLEpl4nytn7veH1ek_6w",
	"header": "_1cHmr102aEhfOG0D32r1zB",
	"grid-sides-margins": "_22bc-kkDntp3G2ZN2DFuWk",
	"gridSidesMargins": "_22bc-kkDntp3G2ZN2DFuWk"
};